import { REPLACEMENT_ERROR, runTemplateForHtml, runTemplateForUrl } from '../engagement-templates';
export function rebuildButtonAction(replacedUrl, action) {
  return {
    ...action,
    data: action.data && {
      ...action.data,
      url: replacedUrl
    }
  };
}
export function runTemplateOnInputs(variables, messageInputs) {
  const keys = Object.keys(messageInputs);
  const output = {};
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const input = messageInputs[key];
    if (input) {
      const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
      const replacedInput = isUrl ? runTemplateForUrl(input, variables) : runTemplateForHtml(input, variables);
      if (replacedInput.type === REPLACEMENT_ERROR) {
        return null;
      }
      output[key] = replacedInput.result;
    }
  }
  return output;
}